<template>
  <WTooltip :label="title" position="right">
    <WButton
      class="p-drawer__button-label"
      variant="tertiary"
      size="small"
      :data-dd-action-name="title"
    >
      <WIcon :icon="icon" />
      <span v-show="showTitle">{{ title }}</span>
      <CNotificationsGroup
        class="p-drawer__notifications"
        :counters="counters"
      />
    </WButton>
  </WTooltip>
</template>

<script>
import { WButton, WIcon, WTooltip } from '@alice-health/wonderland-vue'

import { CNotificationsGroup } from '../'

export default {
  components: { WIcon, CNotificationsGroup, WButton, WTooltip },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    showTitle: Boolean,
    counters: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
button[transparent].p-drawer__button-label {
  border-bottom: var(--gl-border-width-xs) solid transparent;
  border-radius: 0;
  min-height: 34px;
  min-width: 34px;
  padding: var(--gl-spacing-01);

  [data-active] & {
    border-bottom-color: var(--gl-color-shades-magenta-60);
  }

  .p-drawer__notifications {
    margin-left: var(--gl-spacing-01);
  }
}
</style>
